<template>
    <div>
        <div class="icon-wrapper">
            <DSIcon code="default-line/like" size="custom" class="success-icon" />
        </div>
        <h2 class="h2">{{ t('title') }}</h2>
        <p>{{ t('text1') }}</p>
        <p>{{ t('text2') }}</p>
        <div v-if="station" class="contact-info">
            <strong>{{ station.name }}</strong>
            <br />{{ station.street }}
            <br />{{ station.postcode }}, <span class="city">{{ station.city?.toLowerCase() }}</span>
            <br />{{ t('phoneAbbrev') }} {{ station.telephone }}
        </div>
    </div>
</template>
<script setup>
import { useI18n } from '#imports';

defineOptions({
    inheritAttrs: false,
});

defineProps({
    station: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            title: 'Kiitos!',
            text1: 'Asema on yhteydessä, kun tilaus on vahvistettu.',
            text2: 'Jos teit tilauksesi väärin tiedoin ja se pitää peruuttaa tai tarvitset muuten apua tilauksesi kanssa, niin ole yhteydessä suoraan kyseiseen asemaan.',
            text3: 'Jos teit tilauksesi väärin tiedoin ja se pitää peruuttaa tai tarvitset muuten apua tilauksesi kanssa, ota yhteyttä asiakaspalveluumme 0800131 031',
            phoneAbbrev: 'Puh:',
        },
        'en-EU': {
            title: 'Kiitos!',
            text1: 'Informative text about payment is possible on the station and no option to get an invoice and other. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse venenatis.',
            text2: 'The station will be in contact after the offer request has been processed.',
            text3: 'Jos teit tilauksesi väärin tiedoin ja se pitää peruuttaa tai tarvitset muuten apua tilauksesi kanssa, ota yhteyttä asiakaspalveluumme 0800131 031',
        },
    },
});
</script>
<style scoped>
.icon-wrapper {
  width: 10rem;
  height: 10rem;
  margin: 0 auto;
  padding: 2.5rem;
  border: 4px solid var(--color-base-black);
  border-radius: 50%;
}

.success-icon {
  font-size: 4.5rem;
}

.city {
  text-transform: capitalize;
}
</style>
